var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ContainerType } from "@/models/Container";
import { PackingCategory } from "@/models/Item";
import swal from 'sweetalert';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from "vue-property-decorator";
var ItemCardComponent = /** @class */ (function (_super) {
    __extends(ItemCardComponent, _super);
    function ItemCardComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.busy = false;
        return _this;
    }
    Object.defineProperty(ItemCardComponent.prototype, "isClean", {
        get: function () {
            return this.container && this.container.type != ContainerType.Dirty;
        },
        enumerable: true,
        configurable: true
    });
    ItemCardComponent.prototype.categoryDisplay = function () {
        var items = [];
        if (this.item.packingCategory) {
            items.push(this.$t('PackingCategory.' + PackingCategory[this.item.packingCategory]));
        }
        if (this.item.subcategory) {
            items.push(this.item.subcategory);
        }
        return items.join(' &bull; ');
    };
    ItemCardComponent.prototype.setAsDirty = function () {
        var container = this.$store.state.containers.list.find(function (el) { return el.type == ContainerType.Dirty; });
        if (container) {
            this.changeItemContainer(container);
        }
    };
    ItemCardComponent.prototype.setAsClean = function () {
        var container = this.$store.state.containers.list.find(function (el) { return el.type == ContainerType.Default; });
        if (container) {
            this.changeItemContainer(container);
        }
    };
    ItemCardComponent.prototype.toggleItem = function () {
        this.$emit('item-toggle', this.item);
    };
    ItemCardComponent.prototype.deleteItem = function () {
        var _this = this;
        swal({
            title: "Jesteś pewien?",
            text: "Na pewno chcesz usunąć ten przedmiot?",
            icon: "warning",
            dangerMode: true,
            buttons: {
                cancel: true,
                confirm: true,
            },
        })
            .then(function (willDelete) {
            if (willDelete) {
                _this.busy = true;
                _this.$dao.deleteItem(_this.item).then(function () {
                    _this.$emit('item-remove', _this.item);
                    _this.busy = false;
                    swal("Zrobione!", "Przedmiot został usunięty!", "success");
                });
            }
        });
    };
    ItemCardComponent.prototype.changeItemContainer = function (container) {
        var _this = this;
        this.busy = true;
        this.$dao.moveItem(this.item, container).then(function (item) {
            _this.busy = false;
            _this.$emit('item-remove', item);
            _this.$store.commit('modifyDirtyCount', container.type == ContainerType.Dirty ? 1 : -1);
        });
    };
    __decorate([
        Prop()
    ], ItemCardComponent.prototype, "item", void 0);
    __decorate([
        Prop()
    ], ItemCardComponent.prototype, "container", void 0);
    __decorate([
        Prop()
    ], ItemCardComponent.prototype, "packing", void 0);
    __decorate([
        Prop()
    ], ItemCardComponent.prototype, "picked", void 0);
    ItemCardComponent = __decorate([
        Component
    ], ItemCardComponent);
    return ItemCardComponent;
}(Vue));
export default ItemCardComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/item-card/component.ts
// module id = null
// module chunks = 